<label *ngIf="hasLabel()" [for]="inputId" class="FieldLabel">{{ label() }}</label>
<!-- Phone prefix and phone number-->
<div [class.p-inputgroup]="!canSelectCountryCode()" class="flex">
  <span *ngIf="!canSelectCountryCode()" class="p-inputgroup-addon" style="min-width: 3.214em">{{ phonePrefix }}</span>
  <p-dropdown
    #dropdown
    *ngIf="canSelectCountryCode()"
    [inputId]="countryCodeDropdownId"
    [disabled]="disabled()"
    class="countrycode-selector"
    [style]="{ borderRadius: '3px 0 0 3px' }"
    [options]="countryCodes"
    [filter]="countryCodes.length > 5"
    [ariaLabel]="'accessibility.PhoneCountryCode' | translate"
    [tabindex]="focusable() ? 0 : -1"
    [(ngModel)]="selectedCountryItem"
    [overlayOptions]="countryCodeOverlayOptions"
    (onFocus)="announcer.announce('+' + selectedCountryItem().value)"
    (onChange)="onCountryCodeChanged()"
    (keydown)="onCountryCodeKeyDown($any($event))"
    optionLabel="label()"
    selectedItemTemplate="selectedItem"
    [ngModelOptions]="{ standalone: true }"
  >
    <ng-template let-option pTemplate="item">
      <div class="option-container" [attr.data-phone-code]="option.value">
        <div class="flag-option">
          <img class="flag-icon mr-2" [src]="'/StaticFiles/images/flagpedia/' + option.icon + '.png'" [attr.alt]="option.label" />
          <span aria-hidden="true">{{ option.title }}</span>
        </div>
        <span aria-hidden="true" class="right-aligned">+{{ option.value }}</span>
      </div>
      <hr class="horizontal-separator m-0 mt-2" *ngIf="countryCodes.length > 5 && option.icon === 'FI'" />
    </ng-template>
    <ng-template pTemplate="selectedItem">
      <div class="option-container">
        <div class="flag-option">
          <img class="flag-icon mr-2" [src]="'/StaticFiles/images/flagpedia/' + selectedCountryItem().icon + '.png'" [alt]="selectedCountryItem().label" />
          <span aria-hidden="true" class="selected-country-label">+{{ selectedCountryItem().value }}</span>
        </div>
      </div>
    </ng-template>
  </p-dropdown>
  <input
    #input
    pInputText
    autocomplete="tel-national"
    data-uitest="phone-input"
    [id]="inputId"
    class="w-12"
    [tabindex]="focusable() ? 0 : -1"
    [ariaLabel]="(isLandLine() ? 'shared.LandlineNumber' : 'shared.MobileNumber') | translate"
    [attr.aria-invalid]="controlRef?.invalid"
    [class.ng-invalid]="controlRef?.errors && controlRef?.dirty"
    [disabled]="disabled()"
    [placeholder]="(isLandLine() ? 'shared.EnterLandline' : 'shared.EnterMobileNumber') | translate"
    (focus)="hasFocus.set(true)"
    (blur)="hasFocus.set(false); onTouched()"
    [(ngModel)]="inputValue"
    (ngModelChange)="onChange(input.value)"
  />

  <p-dropdown
    *ngIf="canSelectPhoneType()"
    class="mt-auto"
    styleClass="border-noround border-round-right"
    [(ngModel)]="selectedPhoneType"
    [showClear]="false"
    [disabled]="disabled()"
    [options]="phoneNumberTypes"
    (onChange)="updatePhoneType()"
  />
</div>

<!-- Errors (remember to set the validators on the FormControl instance) -->
<div role="alert" aria-atomic="true">
  <ng-container *ngIf="controlRef?.errors && controlRef?.touched && controlRef?.dirty">
    <p class="field-error" *ngIf="controlRef.errors.required" translate>errorMessages.MustBeFilled</p>
    <!-- Use phoneLengthValidator here from custom validators -->
    <p class="field-error" *ngIf="!phoneLengthIsMinimum() && controlRef.errors.phoneLength" [translateParams]="{ length: phoneLength() }" translate>errorMessages.PhoneMustBeXLong</p>
    <p class="field-error" *ngIf="controlRef.errors.phoneMin" [translateParams]="{ length: phoneLength() }" translate>errorMessages.PhoneMustBeMinXLong</p>
    <p class="field-error" *ngIf="controlRef.errors.phoneMax" [translateParams]="{ length: phoneMaxLength() }" translate>errorMessages.MaxXDigits</p>
    <p class="field-error" *ngIf="controlRef.errors.digitsOnly" translate>errorMessages.OnlyDigits</p>
  </ng-container>
</div>
